import { render, staticRenderFns } from "./LoadingItem.vue?vue&type=template&id=1df97a3c&"
var script = {}
import style0 from "./LoadingItem.vue?vue&type=style&index=0&id=1df97a3c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports